import { useReducer } from 'react';
import { TemplateEditorReducer } from './TemplateEditorReducer';
import {
  defaultContextValues,
  IAction,
  IState,
  TemplateEditorDispatchContext,
  TemplateEditorStateContext,
} from './UseTemplateEditorContext';
import { SampleOnsiteCompilationContext } from './SampleOnsiteCompilationContext/SampleOnsiteCompilationContext';

export interface IValue {
  initialState: IState;
  reducer: (state: IState, action: IAction) => IState;
}

interface ITemplateEditorProviderProps {
  children: any;
  channel: string;
  value?: IValue;
}

export function TemplateEditorProvider({
  children,
  channel,
  value = { initialState: defaultContextValues, reducer: TemplateEditorReducer },
}: ITemplateEditorProviderProps) {
  value.initialState.compilationContext =
    channel === 'onsite' ? SampleOnsiteCompilationContext.createDefaultSample() : value.initialState.compilationContext;

  const [state, dispatch] = useReducer(value.reducer, value.initialState);

  return (
    <TemplateEditorStateContext.Provider value={state}>
      <TemplateEditorDispatchContext.Provider value={dispatch}>{children}</TemplateEditorDispatchContext.Provider>
    </TemplateEditorStateContext.Provider>
  );
}
